import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp } from "@/components/motion/Reveal";
import { FAQ } from "@/data/site";

export default function Faq() {
  return (
    <section id="sss" className="bg-beige/40 py-20 sm:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <div className="text-center mb-12">
          <FadeUp>
            <p className="eyebrow text-gold mb-4">Sıkça Sorulan Sorular</p>
          </FadeUp>
          <FadeUp delay={0.05}>
            <h2 className="font-serif text-espresso text-4xl sm:text-5xl lg:text-6xl">
              Aklınızdaki <span className="italic">Sorular</span>
            </h2>
          </FadeUp>
        </div>

        <FadeUp delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-espresso/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif text-xl sm:text-2xl text-espresso hover:text-gold hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-espresso/70 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
}
